import { CONSTANT } from '@/store/constants';
import { TokenPair } from '@/utils/token-storage';

async function parseErrorMessage(res: Response): Promise<string> {
    try {
        const body = await res.json();
        return body?.message || `Request failed with ${res.status}`;
    } catch {
        return `Request failed with ${res.status}`;
    }
}

export async function fetchNonce(): Promise<string> {
    const res = await fetch(`${CONSTANT.AUTH_API_URL}/v1/auth/nonce`, {
        headers: { 'App-Id': CONSTANT.APP_ID },
    });

    if (!res.ok) {
        throw new Error(await parseErrorMessage(res));
    }

    const data = await res.json();
    return data.nonce;
}

export async function loginWithSiwe(params: {
    address: string;
    message: string;
    signature: string;
}): Promise<TokenPair> {
    const res = await fetch(`${CONSTANT.AUTH_API_URL}/v1/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    });

    if (!res.ok) {
        throw new Error(await parseErrorMessage(res));
    }

    return res.json();
}

export async function refreshTokens(refreshToken: string): Promise<TokenPair> {
    const res = await fetch(`${CONSTANT.AUTH_API_URL}/v1/auth/refresh`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh_token: refreshToken }),
    });

    if (!res.ok) {
        throw new Error(await parseErrorMessage(res));
    }

    return res.json();
}
